import { Box, ButtonBase, ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { SIDEWALK } from "components/funnel/constants";
import { Field, useFormikContext } from "formik";
import { Checkbox } from "formik-material-ui";
import useCart from "hooks/useCart";
import React from "react";
import { FunnelCardContainer } from "ui/funnelCardContainer/FunnelCardContainer";
import HelpTextCard from "components/design-system/molecules/HelpTextCard";

const SubTitle = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: "18px",
  fontWeigh: "600",
}));

const WhiteBackground = styled(ButtonBase)({
  background: "white",
  borderRadius: "10px",
  width: "100%",
  display: "inline-block",
  border: "1px solid rgba(215, 215, 215, 0.7)",
});

export default function ProductRecoveryChoice() {
  const formik = useFormikContext();
  const [cart, dispatch] = useCart();

  return (
    <FunnelCardContainer addBorder>
      <SubTitle mb={2}>
        {cart.selection.length > 1 ? "Reprise de vos anciens appareils" : "Reprise de votre ancien appareil"}
      </SubTitle>
      <div>
        <WhiteBackground
          style={{ border: "1px solid rgba(215, 215, 215, 0.7)" }}
          display="flex"
          disableRipple
          onClick={() => {
            formik.setFieldValue("recoverOldDevice", !formik.values.recoverOldDevice);
            dispatch({
              type: "updateShipping",
              shipping: { recoverOldDevice: !formik.values.recoverOldDevice },
            });
          }}
        >
          <Box>
            <ListItem>
              <ListItemIcon>
                <Field
                  component={Checkbox}
                  color="primary"
                  disableRipple
                  type="checkbox"
                  name="recoverOldDevice"
                  indeterminate={false}
                />
              </ListItemIcon>

              <ListItemText
                alignSelf="center"
                primary={
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2">Je souhaite que l&rsquo;on récupère mon ancien appareil</Typography>
                  </Box>
                }
              />
            </ListItem>
          </Box>
        </WhiteBackground>
        {formik.values.delivery_option_type === SIDEWALK && (
          <HelpTextCard whiteBackground mt={1}>
            Pour une livraison au pied du domicile, vous devez descendre vous-même votre bien à remplacer
          </HelpTextCard>
        )}
      </div>
    </FunnelCardContainer>
  );
}
